export default __webpack_public_path__ + "static/media/smallvan-nav-completed.be5df9fa.svg";